<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="['brandskydd', 'brandskydd', 'Nytt brandskydd']"
			:pagination="pagination"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('fireprotections_edit')"
			@toggleAdd="toggleAdd"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns" @click="closeAdd()">
			<FireProtectionList
				:fireProtections="fireProtections"
				:activeFireProtection="activeFireProtection"
				@delete="askToDelete"
				@edit="editFireProtection"
				@search="getFireProtections()"
				@select="selectFireProtection"
			/>
			<InfoPanel
				v-if="activeFireProtection.id && !isMobile"
				:fireProtection="activeFireProtection"
			/>
		</main>
		<AddFireProtection
			v-if="showAdd"
			@save="saveFireProtection"
			@cancel="closeAdd"
			:editFireProtection="selectedFireProtection"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import FireProtectionList from './components/FireProtectionList';
import AddFireProtection from './modals/AddFireProtection';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';
import InfoPanel from './components/InfoPanel';

export default {
	components: {
		FireProtectionList,
		AddFireProtection,
		DeleteModal,
		TopPanel,
		InfoPanel
	},
	data() {
		return {
			showAdd: false,
			showDelete: false,
			selectedFireProtection: {},
			activeFireProtection: {},
			orderBys: [
				{ name: 'Namn', value: 'Name' },
				{ name: 'Skapad', value: 'Created' }
			]
		};
	},

	watch: {
		'getActiveCompany.id'() {
			this.getFireProtections();
		}
	},

	computed: {
		...mapState('fireProtectionStore', ['searchParams']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('fireProtectionStore', ['fireProtections', 'pagination']),
		...mapGetters('user', ['getActiveCompany']),
		deleteMessage() {
			return this.selectedFireProtection.name
				? `Är du säker på att du vill ta bort ${this.selectedFireProtection.name}?`
				: '';
		}
	},
	methods: {
		...mapActions('fireProtectionStore', [
			'getFireProtections',
			'createFireProtection',
			'updateFireProtection',
			'deleteFireProtection',
			'setCurrentPage',
			'setPageSize'
		]),
		toggleAdd() {
			if (!this.selectedFireProtection.name) {
				this.showAdd = !this.showAdd;
			}

			this.selectedFireProtection = {};
		},
		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAdd = false;
				this.selectedFireProtection = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedFireProtection = {};
			}
		},
		saveFireProtection(fireProtection) {
			if (this.selectedFireProtection.id) {
				this.updateFireProtection(fireProtection).then(() => {
					this.showAdd = false;
					this.selectedFireProtection = {};

					if (fireProtection.id == this.activeFireProtection.id) {
						Object.assign(this.activeFireProtection, fireProtection);
					}
				});
			} else {
				this.createFireProtection(fireProtection).then(() => {
					this.showAdd = false;
				});
			}
		},
		editFireProtection(fireProtection) {
			if (this.selectedFireProtection == fireProtection) {
				this.selectedFireProtection = {};
				this.showAdd = false;
			} else {
				this.selectedFireProtection = fireProtection;
				this.showAdd = true;
			}
		},
		askToDelete(fireProtection) {
			this.showAdd = false;
			Object.assign(this.selectedFireProtection, fireProtection);
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
			this.selectedFireProtection = {};
		},
		deleteSelected() {
			this.deleteFireProtection(this.selectedFireProtection).then(() => {
				this.showDelete = false;
				this.selectedFireProtection = {};
			});
		},
		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getFireProtections();
		},
		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getFireProtections();
		},
		selectFireProtection(fireProtection) {
			if (this.activeFireProtection.id == fireProtection.id) {
				this.activeFireProtection = {};
			} else {
				this.activeFireProtection = Object.assign({}, fireProtection);
			}
		}
	},
	created() {
		this.getFireProtections();
	}
};
</script>
